module.exports = __webpack_public_path__ + "img/13.00.34 未佩戴安全帽.05b515bf.png";